import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';
import { Home, Briefcase, MessageCircle, Star, Lock, CreditCard, Bell, Heart, Search, Menu, X, ChevronDown, Settings, LogOut, User, HelpCircle, Gem, BookOpen } from 'lucide-react';
import styles from './ModernNavBarPureCSS.module.css';
import { jwtDecode } from 'jwt-decode';
import imageLogo from "../../assets/images/LogoBuildStart03.png";
import imageLogoNew from "../../assets/images/BSPLogoNew01.png";
import { useNavigate } from 'react-router-dom'; 

import { SOCIAL_FRONTEND_URL } from '../../config.js';

import api from '../../api/api.js'; 
import UpgradeModal from '../Common/UpgradeModal.js';

const ModernNavbarPureCSS = ({ UserName, prefix, TabActiveId }) => {
  const [activeTab, setActiveTab] = useState(TabActiveId);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [userType, setUserType] = useState('');
  const dropdownRef = useRef(null);
  const [userBadge, setUserBadge] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();


  const [isVerified, setIsVerified] = useState(true); // Default to true to prevent locking before loading
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);


  const [notifications] = useState({
    messages: 3,
    jobs: 2,
    reviews: 1
  });

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsProfileDropdownOpen(false);
    }
  };


const checkSubscriptionStatus = async (bizId) => {
      try {
          // If you have the bizId in the token, pass it. 
          // If your endpoint handles resolving ID internally, you can just call .get('/Subscription/hasValidSubscription')
          const { data } = await api.get(`api/Subscription/hasValidSubscription?bizid=${bizId}`);
          console.log( `hasValidSubscription?bizid=${bizId}`, data);
          setIsVerified(data.isVerified);

          console.log("data.isVerified : ", data.isVerified);


      } catch (error) {
          console.error("Failed to check subscription", error);
          // Optional: Lock on error? Or default to open?
          // setIsVerified(false); 
      }
  };


  useEffect(() => {

    setActiveTab(TabActiveId);


    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    const image = sessionStorage.getItem('userImage');
    //console.log("Image from session storage:", image);
    if (image && image !== "null") {
      setProfileImage(image);
      //console.log("Profile image set:", image);
    }



    const token = localStorage.getItem('token');
    if (token) {
        
        try {

            setIsLoggedIn(true); 
            
            const decodedToken = jwtDecode(token);
            setUserEmail(decodedToken.email || '');

            const myUserType = decodedToken.UserType || '';
            setUserType(myUserType);

            var userId = parseInt(localStorage.getItem('loggedInBusinessId') || '0', 10);

            const devName = localStorage.getItem('developerBusinessName');
            
            if (myUserType === 'Business') {
                setUserBadge('Professional');


                // Check Substiption
                //checkSubscriptionStatus(decodedToken.nameid); // this is the business userId
                checkSubscriptionStatus(userId);

            } else if (myUserType === 'Home' && devName) { // Check if it's a Home user AND has a dev name
                setUserBadge('Developer');
            } else {
                setUserBadge('Homeowner'); // Default for all other Home users
            }
            

        } catch (error) {
            console.error("Error decoding token:", error);
        }
    }
    else {
          // No token
          setIsLoggedIn(false); // User is guest
    }

    return () => {
        window.removeEventListener('sroll', handleScroll);
        document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const navItemsHomeUser = [
    { id: 'home', label: 'Home', icon: Home, href: '/newhome', badge: null },
    { id: 'search', label: 'Search', icon: Search, href: '/map-search-v2', badge: null },
    { id: 'projects', label: 'Projects', icon: Briefcase, href: '/projects', badge: null },
    { id: 'messages', label: 'Messages', icon: MessageCircle, href: '/home_messages', badge: null },
    { id: 'reviews', label: 'Reviews', icon: Star, href: '/business-reviews', badge: null },
    { id: 'saved', label: 'Saved', icon: Heart, href: '/saved-businesses', badge: null },
    { id: 'social', label: 'Social', icon: User, href: `${SOCIAL_FRONTEND_URL}`, badge: null, isExternal: true },

  ];

  const navItemsBusiness = [
    { id: 'home', label: 'Home', icon: Home, href: '/newbusiness', badge: null },
    { id: 'search', label: 'Search', icon: Search, href: '/map-search-v2', badge: null },
    // Job Leads is usually a premium feature too
    { id: 'jobs', label: 'JobLeads', icon: Briefcase, href: '/business-jobs-dashboard', badge: null, locked: !isVerified },
    // Projects is the SaaS tool you want to lock
    { id: 'projects', label: 'Projects', icon: Briefcase, href: '/projects', badge: null, locked: !isVerified },    
    { id: 'messages', label: 'Messages', icon: MessageCircle, href: '/business_messages', badge: null },
    { id: 'reviews', label: 'Reviews', icon: Star, href: '/business-reviews', badge: null },
    { id: 'portfolios', label: 'Portfolio', icon: Star, href: '/business-portfolios', badge: null },
    { id: 'subscription', label: 'Subscription', icon: Gem, href: '/subscription/subscribenew', badge: null },
    { id: 'social', label: 'Social', icon: User, href: `${SOCIAL_FRONTEND_URL}`, badge: null, isExternal: true },
  ];

    const navItemsGuest = [
    { id: 'home', label: 'Home', icon: Home, href: '/' },
  ];


  const handleAccountSettingsClick = () => {
    // Navigate to the new route you defined in App.js
    navigate('/account/change-password');
    setIsProfileDropdownOpen(false); // Close the dropdown after clicking
  };




  const handleNavClick = (item) => {

    if (item.locked) {
        setShowUpgradeModal(true);
        setIsMobileMenuOpen(false);
        return;
    }

    // --- EXTERNAL URLs ---
    if (item.isExternal) {
        // Open in new tab
        window.open(item.href, '_blank', 'noopener,noreferrer');
        setIsMobileMenuOpen(false); // Optional: close menu if open
        return; // Stop here so we don't navigate the current window
    }

    setActiveTab(item.id);
    setIsMobileMenuOpen(false);
    window.location.href = item.href;

  };

  const handleMyProfileClick = () => {

    const userType = jwtDecode(localStorage.getItem('token')).UserType;

    if (userType === 'Business') {
      const businessId = localStorage.getItem('loggedInBusinessId');
      window.location.href = `/business-onboarding-new/${businessId}`;
    } else {
      const loggedInHomeUserId = localStorage.getItem('loggedInHomeUserId');
      window.location.href = `/home-user-profile/${loggedInHomeUserId}`;
    }

  };

  const handleLogout = () => {

    delete api.defaults.headers.common['Authorization'];

    sessionStorage.clear();
    localStorage.clear();


    /*
    console.log("✅ Storage Cleared.");
    
    // 3. DEBUG: Check if it's really gone
    if (!localStorage.getItem('token') && !sessionStorage.getItem('token')) {
        console.log("🎉 Token is GONE. User is logged out.");
    } else {
        console.error("⚠️ Token is STILL HERE!");
    }
        */

    navigate('/', { replace: true });
    //window.location.href = '/';
    //window.location.reload();
  };

  return (
    <>

      {showUpgradeModal && (
        <UpgradeModal 
            title="Unlock Professional Tools"
            message="Project Management and Job Leads are available exclusively to subscribed members. Upgrade to streamline your business."
            onClose={() => setShowUpgradeModal(false)}
        />
      )}


      <nav className={`${styles.modern_navbar} ${isScrolled ? styles.modern_navbar_scrolled : ''}`}>
        <div className={styles.modern_navbar_container}>

<div className={styles.modern_navbar_logo}>
            {/* Logo Image directly in the container */}
            <img
              src={imageLogoNew} 
              alt="Build Start Logo"
              className={styles.nav_logo_image} 
            />

            {/* Badge appears to the right of the logo */}
            {userBadge && (
              <span className={styles.logo_badge}>{userBadge}</span>
            )}
          </div>


<div className={styles.modern_navbar_nav}>
            {(() => {
              // 1. Determine which menu items to show
              let itemsToRender;

              if (!isLoggedIn) {
                itemsToRender = navItemsGuest; // Show Guest menu if no token
              } else {
                // Show Business or Home menu based on userType
                itemsToRender = userType === 'Business' ? navItemsBusiness : navItemsHomeUser;
              }

              // 2. Render the selected items
              return itemsToRender.map((item) => {
                const IconComponent = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => handleNavClick(item)}
                    className={`${styles.nav_item} ${activeTab === item.id ? styles.nav_item_active : ''}`}
                    // Optional: Add opacity style if locked
                    style={item.locked ? { opacity: 0.8 } : {}}
                  >
                    <div className={styles.nav_item_content}>
                      <div className={styles.nav_item_icon_wrapper}>
                        <IconComponent className={styles.nav_item_icon} />
                        
                        {/* RENDER: Lock Icon or Badge */}
                        {item.locked ? (
                            <span className={styles.nav_item_badge} style={{background: '#eab308', color: '#fff', padding: '2px', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%'}}>
                                <Lock size={10} />
                            </span>
                        ) : item.badge && (
                          <span className={styles.nav_item_badge}>
                            {item.badge}
                          </span>
                        )}
                      </div>
                      <span className={styles.nav_item_label}>{item.label}</span>
                    </div>
                    <div className={styles.nav_item_indicator}></div>
                  </button>
                );
              });
            })()}
          </div>



<div className={styles.modern_navbar_right}>
            
            {/* IF LOGGED IN: Show Profile Dropdown */}
            {isLoggedIn ? (
                <div className={styles.profile_dropdown_container} ref={dropdownRef}>
                  <button
                    onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                    className={styles.profile_button}
                  >
                    <img src={profileImage || "/placeholder.svg?height=40&width=40"} alt={UserName} className={styles.profile_avatar} />
                    <div className={styles.profile_info}>
                      <span className={styles.profile_name}>{UserName}</span>
                      {userBadge && <span className={styles.profile_role}>{userBadge}</span>}
                    </div>
                    <ChevronDown className={`${styles.profile_chevron} ${isProfileDropdownOpen ? styles.profile_chevron_open : ''}`} />
                  </button>

                  {isProfileDropdownOpen && (
                    <div className={styles.profile_dropdown_menu}>
                       {/* ... (Your existing dropdown menu code) ... */}
                       <div className={styles.profile_dropdown_header}>
                        <img src={profileImage || "/placeholder.svg?height=48&width=48"} alt={UserName} style={{ width: '3rem', height: '3rem', borderRadius: '50%' }}/>
                        <div>
                          <div style={{ fontWeight: 600, color: '#111827' }}>{UserName}</div>
                          <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{userEmail}</div>
                        </div>
                      </div>
                      <div className={styles.profile_dropdown_divider}></div>
                      <div className={styles.profile_dropdown_items}>
                        <button className={styles.profile_dropdown_item} onClick={handleMyProfileClick}>
                          <User style={{ width: '1rem', height: '1rem' }} />
                          <span>Edit Profile</span>
                        </button>
                        <button className={styles.profile_dropdown_item} onClick={handleAccountSettingsClick}>
                          <Settings style={{ width: '1rem', height: '1rem' }} />
                          <span>Account Settings</span>
                        </button>
                        <button className={styles.profile_dropdown_item}>
                          <HelpCircle style={{ width: '1rem', height: '1rem' }} />
                          <span>Help & Support</span>
                        </button>
                      </div>
                      <div className={styles.profile_dropdown_divider}></div>
                      <button className={`${styles.profile_dropdown_item} ${styles.profile_dropdown_logout}`} onClick={handleLogout}>
                        <LogOut style={{ width: '1rem', height: '1rem' }} />
                        <span>Sign Out</span>
                      </button>
                    </div>
                  )}
                </div>
            ) : (
                /* ELSE: Show Login / Register Buttons (NEW) */
                <div className={styles.headerRight}>
                  <Link to="/login" className={styles.btnRegister}>Login</Link>
                  <Link to="/select-role" className={styles.btnRegister}>Register</Link>
                </div>
            )}

            {/* Mobile Menu Button */}
            <button
              className={styles.mobile_menu_button}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X style={{ width: '1.5rem', height: '1.5rem' }} /> : <Menu style={{ width: '1.5rem', height: '1.5rem' }} />}
            </button>
          </div>



        </div>

{isMobileMenuOpen && (
        <div className={styles.mobile_nav_overlay}>
          <div className={styles.mobile_nav_menu}>
            
            {/* 1. Dynamic Navigation Items */}
            {(() => {
              // Determine which menu items to use
              let itemsToRender;

              if (!isLoggedIn) {
                itemsToRender = navItemsGuest;
              } else {
                itemsToRender = userType === 'Business' ? navItemsBusiness : navItemsHomeUser;
              }

              return itemsToRender.map((item) => {
                const IconComponent = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => handleNavClick(item)}
                    className={`${styles.mobile_nav_item} ${activeTab === item.id ? styles.mobile_nav_item_active : ''}`}
                    style={item.locked ? { opacity: 0.8 } : {}}
                  >
                    <div className={styles.mobile_nav_item_icon_wrapper}>
                      <IconComponent style={{ width: '1.5rem', height: '1.5rem' }} />
                      
                      {/* Mobile Lock Icon or Badge */}
                      {item.locked ? (
                          <span className={styles.mobile_nav_badge} style={{
                              background: '#eab308', 
                              color: '#fff', 
                              padding: '2px', 
                              display: 'flex', 
                              alignItems: 'center', 
                              justifyContent: 'center',
                              borderRadius: '50%',
                              width: '16px',
                              height: '16px'
                          }}>
                              <Lock size={10} />
                          </span>
                      ) : item.badge && (
                        <span className={styles.mobile_nav_badge}>
                          {item.badge}
                        </span>
                      )}
                    </div>
                    <span className={styles.mobile_nav_item_label}>{item.label}</span>
                  </button>
                );
              });
            })()}

            {/* 2. Mobile Auth Buttons (Only visible if NOT logged in) */}
            {!isLoggedIn && (
                <div style={{ 
                    padding: '20px', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '12px', 
                    borderTop: '1px solid #f3f4f6', 
                    marginTop: '20px' 
                }}>
                    <button 
                      className={styles.login_button_nav} 
                      style={{
                          width:'100%', 
                          textAlign:'center', 
                          border:'1px solid #e5e7eb', 
                          justifyContent: 'center',
                          padding: '12px'
                      }}
                      onClick={() => {
                          setIsMobileMenuOpen(false);
                          navigate('/login');
                      }}
                    >
                      Log In
                    </button>
                    <button 
                      className={styles.signup_button_nav} 
                      style={{
                          width:'100%', 
                          textAlign:'center', 
                          justifyContent: 'center',
                          padding: '12px'
                      }}
                      onClick={() => {
                          setIsMobileMenuOpen(false);
                          navigate('/register');
                      }}
                    >
                      Sign Up Free
                    </button>
                </div>
            )}
            
          </div>
        </div>
      )}

      </nav>

      {isMobileMenuOpen && (
        <div 
          className={styles.mobile_nav_backdrop}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default ModernNavbarPureCSS;
